import { Model, useRepo } from "pinia-orm";
import Category from "./Category";
import Answer from "./Answer";

export default class Questionnaire extends Model {
  static entity = "questionnaires";

  static primaryKey = "uuid";

  static fields() {
    return {
      uuid: this.uid(""),
      createdAt: this.attr(""),
      updatedAt: this.attr(""),
      name: this.string(""),
      order: this.attr(1),
      isArchived: this.attr(false),
      isMandatory: this.attr(false),
      isAdminOnly: this.attr(false),
      missionCodes: this.attr([]),
      destinationCodes: this.attr([]),
      typeCodes: this.attr([]),
      categoryUuid: this.attr(null),
      categories: this.hasMany(Category, "questionnaireUuid"),
      lastModifiedByEmail: this.string(),
      extraData: this.attr({ topics: [] }),
      objectRelatedUuids: this.attr([]),
    };
  }

  static getAllQuestions = (questionnaire) => {
    // Get all the questions of the questionnaire in an array
    // questionnaire is a vuex orm object fetch with recursive fields
    const addChildrenQuestions = (questionsArray) => {
      questionsArray.forEach((question) => {
        questions.push(question);
        if (question.children.length > 0) {
          addChildrenQuestions(question.children);
        }
      });
    };
    const questions = [];
    addChildrenQuestions(questionnaire.categories.flatMap((category) => category.questions) ?? []);
    return questions;
  };

  static hasAnswers = (questionnaire) => {
    const answerRepo = useRepo(Answer);
    // Check if questionnaire has at least one answer
    const questions = questionnaire.categories.flatMap((category) => category.questions);
    return (
      questions.some((question) => question.indeterminate) ||
      questions.some((question) => answerRepo.where("question", question.uuid).first()?.value)
    );
  };
}
